import moment from 'moment'

const holidays = {
  // 2019
  '2019-01-01': '새해', // 화
  '2019-02-04': '설날', // 월
  '2019-02-05': '설날', // 화
  '2019-02-06': '설날', // 수
  '2019-03-01': '삼일절', // 금
  '2019-05-01': '노동절', // 수
  '2019-05-06': '어린이날', // 월,대체
  '2019-06-06': '현충일', // 목
  '2019-08-15': '광복절', // 목
  '2019-09-12': '추석', // 목
  '2019-09-13': '추석', // 금
  '2019-10-03': '개천절', // 목
  '2019-10-09': '한글날', // 수
  '2019-12-25': '크리스마스', // 수

  // 2020
  '2020-01-01': '새해', // 수
  '2020-01-24': '설날', // 금
  '2020-01-25': '설날', // 토
  '2020-01-26': '설날', // 일
  '2020-03-01': '삼일절', // 일
  '2020-04-30': '부처님 오신 날', // 목
  '2020-05-05': '어린이날', // 화
  '2020-06-06': '현충일', // 토
  '2020-08-15': '광복절', // 토
  '2020-09-30': '추석', // 수
  '2020-10-01': '추석', // 목
  '2020-10-02': '추석', // 금
  '2020-10-03': '개천절', // 토
  '2020-10-09': '한글날', // 금
  '2020-12-25': '크리스마스', // 금
}

export function isHoliday(date) {
  const dateStr = moment(date).format('YYYY-MM-DD')
  return !!holidays[dateStr]
}

export function isBusinessDay(date) {
  const mdate = moment(date)
  if (mdate.day() === 0 || mdate.day() === 6) {
    return false
  }

  const dateStr = mdate.format('YYYY-MM-DD')
  return !holidays[dateStr]
}

export function getLastBusinessDay(month) {
  const mdate = moment(month, month[4] === '-' ? 'YYYY-MM' : 'YYYYMM').endOf(
    'month'
  )

  while (!isBusinessDay(mdate)) {
    mdate.subtract(1, 'day')
  }

  return mdate.format('YYYY-MM-DD')
}

export function getLastDay(month, format = 'YYYY-MM-DD') {
  return moment(month, month[4] === '-' ? 'YYYY-MM' : 'YYYYMM')
    .endOf('month')
    .format(format)
}

export const DateFormat = {
  DateTime: 'YYYY-MM-DD HH:mm',
  DateTimeLong: 'YYYY-MM-DD HH:mm:ss',
  Date: 'YYYY-MM-DD',
  Time: 'HH:mm',
  TimeLong: 'HH:mm:ss',
}

export function formatDate(date, format = DateFormat.DateTime) {
  return date ? moment(date).format(format) : ''
}

export function iterateDateOverMonth(month, iterFunc) {
  const curDate = moment(`${month}-01`).startOf('month')
  const lastDay = moment(`${month}-01`).endOf('month')

  while (curDate.isSameOrBefore(lastDay)) {
    iterFunc(curDate, curDate.format('YYYY-MM-DD'), curDate.format('DD'))
    curDate.add(1, 'day')
  }
}

export function getDaysInMonth(month) {
  return moment(month.replace('-', '').slice(0, 6), 'YYYYMM')
    .endOf('month')
    .daysInMonth()
}

export function isCurrentMonth(month) {
  return month.replace('-', '') === moment().format('YYYYMM')
}

export function addHours(date, hours) {
  return new Date(date.getTime() + hours * 3600000)
}

export function addDays(date, days) {
  return new Date(date.getTime() + days * 24 * 3600000)
}

export function getMonthBefore(month, period) {
  return moment(month)
    .subtract(period, 'months')
    .format(month.includes('-') ? 'YYYY-MM' : 'YYYYMM')
}

export default {
  isHoliday,
  isBusinessDay,
  getLastBusinessDay,
  getLastDay,
  formatDate,
  DateFormat,
  iterateDateOverMonth,
  getDaysInMonth,
  isCurrentMonth,
  addHours,
  addDays,
  getMonthBefore,
}
